import { Component, ViewChild, Input, Inject, AfterViewInit, OnInit, EventEmitter, DOCUMENT } from '@angular/core';
import { environment } from '../../../environments/environment';

import { GenericService } from '../../../common/common.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { DataService } from '../../../common/data.service';
import { HttpClient, HttpResponse, HttpRequest, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LazyLoadingService } from '../../../common/lazyloading';
import { PowerBIParam,PowerBIReportConfig } from '../PowerBIControl/PowerBI.model'
import { IReportEmbedConfiguration, models, Page, Report, service, VisualDescriptor } from 'powerbi-client';
import { PowerBIReportEmbedComponent } from 'powerbi-client-angular';
import 'powerbi-report-authoring';
import { UtilityService } from '../../../common/utility.service';


@Component({
    selector: 'app-PowerBI-Component',
    templateUrl: './PowerBI.component.html',
    styleUrls: ['./PowerBI.component.css'],
    outputs: ['onInitialized'],
    standalone: false
})
///Component can be integrated with parent component 
export class PowerBI implements OnInit {

  onInitialized = new EventEmitter<PowerBI>();

  reportConfig: IReportEmbedConfiguration = {
    type: 'report',
    embedUrl: undefined,
    tokenType: models.TokenType.Embed,
    accessToken: undefined,
    settings: undefined,
  };

  // Flag which specify the type of embedding
  phasedEmbeddingFlag = false;
  reportClass = 'report-container ';

  eventHandlersMap = new Map<string, (event?: service.ICustomEvent<any>) => void>([
    ['loaded', () => console.log('Report has loaded')],
    [
      'rendered',
      () => {
        console.log('Report has rendered');


      },
    ],
    [
      'error',
      (event?: service.ICustomEvent<any>) => {
        if (event) {
          console.error(event.detail);
        }
      },
    ],
    ['visualClicked', () => console.log('visual clicked')],
    ['pageChanged', (event) => console.log(event)],
  ]);

  public __bIsLoadingVisible: boolean = false;

  @Input()
  __sInstanceId: number = 0;

  @Input()
  __sStateDataId: number = 0;

  @Input()
  __sValue: any = "";

  @Input()
  __sDataCaption: string = "";

  @Input()
  __sDataTypeParameter: string = "";


  constructor(@Inject(DOCUMENT) public document: any, public service: GenericService, public route: ActivatedRoute, public router: Router, public data: DataService, public http: HttpClient, public datePipe: DatePipe, public lazyLoadingService: LazyLoadingService, public __oUtilityService: UtilityService) {

  }

  // fires on post view renders
  ngAfterViewInit(): void {
  }

  // fires on initialization
  ngOnInit() {

    this.onInitialized.emit(this);

  }

  /// Events

  

  /// component public methods can be called from parent component

  public Refresh(ScurrentInstanceStateData:string) {

    this.__bIsLoadingVisible = true;

    if (!this.__oUtilityService.IsNullOrUndefined(this.__sValue)) {

      this.LoadReport(ScurrentInstanceStateData);

    }
    else {
      this.__bIsLoadingVisible = false;
    }

    

  }

  public RefreshSilent(ScurrentInstanceStateData: string) {    

    if (!this.__oUtilityService.IsNullOrUndefined(this.__sValue)) {

      this.LoadReport(ScurrentInstanceStateData);

    }

  }


  private LoadReport(ScurrentInstanceStateData: string) {
    let oBusinessProcessParam = new PowerBIParam();
    oBusinessProcessParam.lwfBusinessProcessInstanceId = this.__sInstanceId;
    oBusinessProcessParam.sCurrentInstanceData = ScurrentInstanceStateData;
    oBusinessProcessParam.ReportName = this.__sValue;
    oBusinessProcessParam.sDataCaption = this.__sDataCaption;
    oBusinessProcessParam.lwfBusinessProcessStateDataId = this.__sStateDataId;
    oBusinessProcessParam.DataTypeParameter = this.__sDataTypeParameter;

    this.service.UpdateAllDataByPromise(oBusinessProcessParam, this.__oUtilityService.GetBasewebAPIURL() + "api/WorkflowDashBoard/PowerBIReportConfig").then(
      result => this.OnSuccessPowerBIReportConfig(result)
    ).
      catch(error => this.OnErrorPowerBIReportConfig(error)) 

  }


  private OnErrorPowerBIReportConfig(error: any) {
    this.__bIsLoadingVisible = false;
    console.log(error);
  }
  private OnSuccessPowerBIReportConfig(response: any) {

    if (response != null) {

      this.reportConfig = {
        ...this.reportConfig,
        id: response.Id,
        embedUrl: response.embedUrl ,
        accessToken: response.accessToken,
      };
    }

    this.__bIsLoadingVisible = false;

  }



  public GetData() {
    
   
  }

 
}
